import React from 'react';
import styled from 'styled-components';

import { grayBorder } from './Colors';
import { WindowHeaderHeight } from './sizes';

const Container = styled.div`
  width: 100%;
  display: flex;
  height: ${WindowHeaderHeight}px;
  grid-template-columns: 15px auto 15px;
  font-size: 12px;
  justify-content: space-between;
  color: gray;
  ${grayBorder}
`;
const IconContainer = styled.div`
  width: 15px;
  ${grayBorder}
`;

export default function WindowHeader({ name }: { name: string }) {
  return (
    <Container>
      <IconContainer></IconContainer>
      <div>{name}</div>
      <IconContainer></IconContainer>
    </Container>
  );
}
